module.exports = __webpack_public_path__ + "img/documenti_smartform.789623f2.png";